import VeeValidate from "vee-validate";
import VeeValidateRules from "./rules";
import dictionary from "./dictionary";

class VeeValidatePlugin {
    setup() {
        VeeValidate.Validator.extend("phone", VeeValidateRules.PhoneNumber);
        VeeValidate.Validator.extend("no_spaces", VeeValidateRules.no_spaces);
        VeeValidate.Validator.extend("pathCustom", VeeValidateRules.Path);
        VeeValidate.Validator.extend("not_digits", VeeValidateRules.not_digits);
        VeeValidate.Validator.extend("not_symbols", VeeValidateRules.not_symbols);
        VeeValidate.Validator.extend("password_level_1", VeeValidateRules.password_level_1);
        VeeValidate.Validator.extend("not_symbols_allowed_space", VeeValidateRules.not_symbols_allowed_space);
        VeeValidate.Validator.extend("ensure_url", VeeValidateRules.ensure_url);
        VeeValidate.Validator.extend("customer_identity_number", VeeValidateRules.customer_identity_number);
        VeeValidate.Validator.extend("not_allowed_vietnamese", VeeValidateRules.not_allowed_vietnamese);
        VeeValidate.Validator.extend("different", VeeValidateRules.different);
        VeeValidate.Validator.extend("different_pw", VeeValidateRules.different_pw);
        VeeValidate.Validator.extend("ten_length", VeeValidateRules.ten_length);
        VeeValidate.Validator.extend("cmnd_number", VeeValidateRules.cmnd_number);
        VeeValidate.Validator.extend("cmnd_name", VeeValidateRules.cmnd_name);
        VeeValidate.Validator.extend("custom_required", VeeValidateRules.required);

        VeeValidate.Validator.localize(dictionary);
    }
}

const veeValidatePlugin = new VeeValidatePlugin();

export default veeValidatePlugin;



// WEBPACK FOOTER //
// ./src/plugins/veeValidate/index.js